import { instance } from "./apiRequest";
import {
    SESSION_TOKEN,
    LOGIN
} from "../constants/constants";
import {
    getPrivateRoutesByRole,
    SUPER_ADMIN_ROLE_ID,
    LOAN_OFFICER_ROLE_ID,
    SENIOR_PRIVATE_BANKER_ROLE_ID,
    UNDERWRITER_BANKER_ROLE_ID,
    PRIVATE_WEALTH_ADVISOR_ROLE_ID,
    CLIENT_ROLE_ID,
    COMPLIANCE_ADMIN_ROLE_ID,
    FIRM_ADMIN_ROLE_ID,
} from "../constants/DataConstants";

// function matchRoutePattern(pathname, routePattern) {
//     const regexPattern = '^' + routePattern.replace(/:\w+/g, '[^/]+') + '$';
//     const regex = new RegExp(regexPattern);
//     return regex.test(pathname);
// }

function matchRoutePattern(pathname, routePattern) {
    if (typeof routePattern !== "string") {
        console.warn("Invalid routePattern:", routePattern);
        return false;
    }

    const regexPattern =
        '^' + routePattern.replace(/:\w+/g, '[^/]+') + '$';

    return new RegExp(regexPattern).test(pathname);
}

let _authService = {

    isAuthenticated(obj) {
        const privateRoutesByRole = getPrivateRoutesByRole();

        const pathname = obj.location.pathname;

        const RoleId = Number(localStorage.getItem("RoleId") ?? 0);

        const Role = localStorage.getItem("Role") ?? "";

        // const IsFirmAdmin = localStorage.getItem("FirmAdmin") === "true";

        const IsFirmAdmin = JSON.parse(localStorage.getItem("FirmAdmin") || "false");


        if (RoleId === CLIENT_ROLE_ID && Role === "Applicant" && IsFirmAdmin === false) {
            let isRouteExists = privateRoutesByRole && privateRoutesByRole.client &&
                privateRoutesByRole.client.some(route => matchRoutePattern(pathname, route));

            if (!isRouteExists) {
                localStorage.clear();
                window.sessionStorage.clear();
                return false;
            }
        } else if (RoleId === FIRM_ADMIN_ROLE_ID && Role === "Applicant" && IsFirmAdmin === true) {
            let isRouteExists = privateRoutesByRole && (
                (privateRoutesByRole.client && privateRoutesByRole.client.some(route => matchRoutePattern(pathname, route))) ||
                (privateRoutesByRole.firmadmin && privateRoutesByRole.firmadmin.some(route => matchRoutePattern(pathname, route)))
            );

            if (!isRouteExists) {
                localStorage.clear();
                window.sessionStorage.clear();
                return false;
            }
        } else if (RoleId === FIRM_ADMIN_ROLE_ID && Role === "FirmAdmin" && IsFirmAdmin === true) {
            
            let isRouteExists = privateRoutesByRole && privateRoutesByRole.firmadmin &&
                privateRoutesByRole.firmadmin.some(route => matchRoutePattern(pathname, route));

            if (!isRouteExists) {
                localStorage.clear();
                window.sessionStorage.clear();
                return false;
            }
        } else if (RoleId === SENIOR_PRIVATE_BANKER_ROLE_ID) {
            let isRouteExists = privateRoutesByRole && privateRoutesByRole.seniorPrivateBanker &&
                privateRoutesByRole.seniorPrivateBanker.some(route => matchRoutePattern(pathname, route));

            if (!isRouteExists) {
                localStorage.clear();
                window.sessionStorage.clear();
                return false;
            }
        } else if (RoleId === UNDERWRITER_BANKER_ROLE_ID) {
            let isRouteExists = privateRoutesByRole && privateRoutesByRole.underwriterBanker &&
                privateRoutesByRole.underwriterBanker.some(route => matchRoutePattern(pathname, route));

            if (!isRouteExists) {
                localStorage.clear();
                window.sessionStorage.clear();
                return false;
            }
        } else if (RoleId === LOAN_OFFICER_ROLE_ID) {
            let isRouteExists = privateRoutesByRole && privateRoutesByRole.loanOfficer &&
                privateRoutesByRole.loanOfficer.some(route => matchRoutePattern(pathname, route));

            if (!isRouteExists) {
                localStorage.clear();
                window.sessionStorage.clear();
                return false;
            }
        } else if (RoleId === SUPER_ADMIN_ROLE_ID) {
            let isRouteExists = privateRoutesByRole && privateRoutesByRole.bankadmin &&
                privateRoutesByRole.bankadmin.some(route => matchRoutePattern(pathname, route));

            if (!isRouteExists) {
                localStorage.clear();
                window.sessionStorage.clear();
                return false;
            }
        } else if (RoleId === PRIVATE_WEALTH_ADVISOR_ROLE_ID) {
            let isRouteExists = privateRoutesByRole && privateRoutesByRole.privateWealthAdvisor &&
                privateRoutesByRole.privateWealthAdvisor.some(route => matchRoutePattern(pathname, route));

            if (!isRouteExists) {
                localStorage.clear();
                window.sessionStorage.clear();
                return false;
            }
        } else if (RoleId === COMPLIANCE_ADMIN_ROLE_ID) {
            let isRouteExists = privateRoutesByRole && privateRoutesByRole.complianceAdministrator &&
                privateRoutesByRole.complianceAdministrator.some(route => matchRoutePattern(pathname, route));

            if (!isRouteExists) {
                localStorage.clear();
                window.sessionStorage.clear();
                return false;
            }
        }
        return (
            localStorage.getItem(SESSION_TOKEN) !== undefined &&
            localStorage.getItem(SESSION_TOKEN) !== null &&
            localStorage.getItem(SESSION_TOKEN) !== ""
        );
    },

    async userLogout() {
        localStorage.clear();
        window.sessionStorage.clear();
        window.location.href = "/";
    },

    async login(requestBody) {
        return await instance.post(LOGIN, requestBody);
    },
};

export default _authService;
